import { render, staticRenderFns } from "./voiceControl.vue?vue&type=template&id=11d01a3a&scoped=true&"
import script from "./voiceControl.vue?vue&type=script&lang=js&"
export * from "./voiceControl.vue?vue&type=script&lang=js&"
import style0 from "./voiceControl.vue?vue&type=style&index=0&id=11d01a3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d01a3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11d01a3a')) {
      api.createRecord('11d01a3a', component.options)
    } else {
      api.reload('11d01a3a', component.options)
    }
    module.hot.accept("./voiceControl.vue?vue&type=template&id=11d01a3a&scoped=true&", function () {
      api.rerender('11d01a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/voiceControl.vue"
export default component.exports